<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Personal reference</Text>

      <slot name="actions" />
    </template>

    <View gap="sm" direction="column" v-if="referenceDetails">
      <Text variant="label-medium" color="tertiary">{{ referenceDetails.relationship }}</Text>
      <Text variant="body-medium">{{ referenceDetails.fullName }}</Text>
      <Text variant="body-medium">{{ referenceDetails.phoneNumber }}</Text>
      <Text variant="body-medium">{{ referenceDetails.email }}</Text>
    </View>

    <template v-else>
      <Text variant="body-medium">No info</Text>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';

import { ApplicationReferenceDto } from '../../interfaces/application-reference.interface';

defineProps<{ referenceDetails: ApplicationReferenceDto | null | undefined }>();
</script>

<style scoped lang="scss"></style>
